import { render, staticRenderFns } from "./SheetYear.vue?vue&type=template&id=b127c84a&scoped=true&"
import script from "./SheetYear.vue?vue&type=script&lang=js&"
export * from "./SheetYear.vue?vue&type=script&lang=js&"
import style0 from "./SheetYear.vue?vue&type=style&index=0&id=b127c84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b127c84a",
  null
  
)

export default component.exports